import {Injectable} from '@angular/core';

import Season from '@app/core/models/enumerations/season.model';
import {SeasonService} from '@app/core/services/season/season.service';

import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export default class SeasonState {
  private readonly _seasons$  = new BehaviorSubject<Season[]>([]);
  public seasons$             = this._seasons$.asObservable();
  private readonly _selected$ = new BehaviorSubject<string>(null);
  public selected$            = this._selected$.asObservable();

  constructor(private readonly _service: SeasonService) {
    this.getSeasons();
  }

  public getSeasons(): void {
    this._service.getLearningRateQuadrantReportSeasons().pipe(
      filter(data => Boolean(data.length))
    ).subscribe(value => {
      this._seasons$.next(value);
      this.updateSeason(this.getSelected());
    });
  }

  public getSelected(): string {
    const option = this._seasons$.value[0];
    return `${option.seasonName} ${option.seasonYear}`;
  }

  public updateSeason(value: string): void {
    this._selected$.next(value);
  }
}
